import { useQuery } from '@tanstack/react-query';
import { api } from 'src/services/api';
import { Tag } from 'src/models';
import { groupBy } from 'lodash';
import { UseQueryOverrideOptions } from '../common';

export type UseGetTagListParams = {
  search?: string;
};

export type GetTagListResponse = {
  tags: Tag[];
};

export const useGetTagList = (
  params: UseGetTagListParams,
  options: UseQueryOverrideOptions = {}
) => {
  const { search } = params;

  return useQuery({
    queryKey: ['tagList', params],
    queryFn: () =>
      api
        .get<GetTagListResponse>(`/v3/tag`)
        .then(({ data }) => {
          let { tags } = data;
          if (search) {
            tags = (tags || []).filter((tag) =>
              tag.name.toLowerCase().includes(search.toLowerCase())
            );
          }
          return { data: { tags } };
        })
        .then(({ data }) => {
          const groupedTags = groupBy(data.tags, 'category');
          return { tags: data.tags, groupedTags };
        }),
    ...options,
  });
};
